import React from "react";

export function useGlobalHandler(name: string, handler: any) {

	React.useEffect(() => {
		window.addEventListener(name, handler);

		return () => {
			window.removeEventListener(name, handler);
		}
	}, [name, handler]);

}